import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=5ce33f87&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=5ce33f87&prod&scoped=true&lang=css"
import style1 from "./Alerts.vue?vue&type=style&index=1&id=5ce33f87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce33f87",
  null
  
)

export default component.exports